import React from 'react'
import { Field, useFormikContext } from 'formik'
import { Button, Grid } from '@mui/material'
import { CustomTextField } from 'src/form'
import { LabOrderPatientHistory } from 'src/graphql.generated'
import useOpenLabReport from 'src/labOrder/useOpenLabReport'

export const getInitialValuesFromLabOrderPatientHistoryEntry = (entry: LabOrderPatientHistory) => {
  const { labOrder } = entry

  return {
    value: {
      orderID: labOrder?.orderID,
    },
  }
}

export type LabOrderSchema = {
  orderID?: string
}

const LabOrderFields = () => {
  const { values } = useFormikContext<{ value: LabOrderSchema }>()
  const [openReport, openReportStatus] = useOpenLabReport()

  const {orderID} = values.value

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Field component={CustomTextField} label="Order ID" name="value.orderID" fullWidth />
      </Grid>
      {orderID && (
        <Grid item xs={12}>
          <Button disabled={openReportStatus.loading} onClick={() => openReport(orderID)}>
            Open results
          </Button>
        </Grid>
      )}
    </Grid>
  )
}

export default LabOrderFields
